import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import PartnersPopup from "./PartnersPopup";

export default function Header() {
  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6">Карта заправок</Typography>
        <PartnersPopup></PartnersPopup>
      </Toolbar>
    </AppBar>
  );
}
